import { inject, Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';
import { User } from '../auth.service';

@Injectable({
  providedIn: 'root',
})
export class CurrentUserService {
  private router: Router = inject(Router)

  public currentUserSubject = new BehaviorSubject<User | null>(null);
  logout(preserveRoute = false): Promise<void> {
    return new Promise<void>((resolve) => {
      const returnUrl = preserveRoute
        ? this.router.url
        : null;
  
      setTimeout(() => {
        this.currentUserSubject.next(null);
        this.clearStoredUser();
  
        this.router.navigate(['/login'], {
          queryParams: returnUrl ? { returnUrl } : undefined,
        });
  
        resolve();
      }, 500);
    });
  }

  // Clear stored user data
  private clearStoredUser(): void {
    if (typeof window !== 'undefined' && window.localStorage) {
      localStorage.removeItem('currentUser');
      sessionStorage.removeItem('currentUser');
    }
  }
}
